type Params = {
  propertyValue?: string;
  secondaryApplicantExist: string | null;
  primaryApplicantIncome: string;
  secondaryApplicantIncome: string;
  downpayment: string;
};

export function parseFormData(formData?: Params) {
  if (!formData) {
    return {
      propertyValue: undefined,
      secondaryApplicantExist: undefined,
      primaryApplicantIncome: undefined,
      secondaryApplicantIncome: undefined,
      downpayment: undefined,
    };
  }

  return {
    propertyValue: formData.propertyValue ? parseInt(formData.propertyValue) : undefined,
    secondaryApplicantExist: formData.secondaryApplicantExist === '1',
    primaryApplicantIncome: parseInt(formData.primaryApplicantIncome),
    secondaryApplicantIncome:
      formData.secondaryApplicantIncome && formData.secondaryApplicantExist === '1'
        ? parseInt(formData.secondaryApplicantIncome)
        : undefined,
    downpayment: parseInt(formData.downpayment),
  };
}
